const parseBoolean = (value?: string | null) => {
  if (value === undefined || value === null) return false;

  const normalized = value.toString().trim().toLowerCase();

  if (['1', 'true'].includes(normalized)) return true;

  if (['0', 'false'].includes(normalized)) return false;

  return false;
};

export default parseBoolean;
